import styled from 'styled-components';
export const CardForm = styled.form`
  box-sizing: border-box;
  height: auto;
  width: 402px;
  border: 1px solid rgba(220, 224, 228, 1);
  border-radius: 8px;
  background-color: rgba(247, 248, 250, 1);
  margin: 37px 44px;
  padding: 27px 27px 31px 27px;
`;
export const CardWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  & > :first-child {
    width: 100%;
    margin-top: 2vh;
  }
  & > :nth-child(2) {
    width: 48%;
    margin: 2vh 2% 0 0;
  }
  & > :last-child {
    width: 48%;
    margin: 2vh 0 0 2%;
  }
`;
export const CardFieldContainer = styled.div`
  & > :nth-child(2) {
    padding: 10px 15px 5px 15px;
    box-sizing: border-box;
    border-radius: 8px;
    height: 25px;
    position: relative;
    width: 100%;
    min-height: 40px;
    background-color: #ffffff;
    border: 1px solid var(--LightGray);
    pointer-events: all;
    cursor: default;
  }
  & > div:first-of-type {
    & > :first-child {
      display: flex;
      align-items: center;
      & > :first-child {
        margin-top: 12px !important;
      }
    }
  }
`;
export const SetDefaultComponent = styled.div`
  margin-top: 31px;

  span {
    margin-left: -5px;
    color: rgba(93, 110, 129, 1);
    font-size: 16px;
    letter-spacing: 0;
    line-height: 12px;
    font-weight: 300;
  }
`;

export const ContentActionModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 32px 44px;
`;
